// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3z9Sb","list":"PatternAutocomplete_list__3exVR"};